import Vue from 'vue'
import Vuex from 'vuex'
import axios from "../common/req";
import {getCurrentTimeRange, getDate} from "../common/tool";

Vue.use(Vuex)


const timeText = ['预告', '直播中', '回放'];
export default new Vuex.Store({
  state: {
    info: null, // false 表示当前活动不存在
    tabs: null,
    admission: null
  },
  getters: {
    info: state => state.info,
    tabs: state => state.tabs,
    admission: state => state.admission,
  },
  mutations: {
    updateInfo(state, info) {
      state.info = info;
    },
    setTabs(state, tabs) {
      state.tabs = tabs;
    },
    setAdmission(state, admission) {
      state.admission = admission;
    },
  },
  actions: {
    getAct(context, alias) {
      axios.get(`/activity-school?filter[alias]=${alias}`).then(res => {
        let list = res.data;
        if(list && list.length > 0) {
          let info = list[0];
          document.title = info.title;
          let conf = JSON.parse(info.school_config);
          let admission = conf.admission;
          let tabs = JSON.parse(info.tab);
          tabs.forEach(tab => {
            if(tab.list) {
              tab.list.forEach(item => {
                if(item.time && item.time.length > 1) {
                  item.status = getCurrentTimeRange(item.time[0], item.time[1]);
                  item.startText = getDate(item.time[0]).pattern('MM/dd/HH:mm');
                  item.statusText = timeText[item.status - 1];
                } else {
                  item.status = null;
                }
                if(item.enroll && item.enroll.length > 1) {
                  item.es =  getCurrentTimeRange(item.enroll[0], item.enroll[1]);
                } else {
                  item.es = null;
                }
              });
            }
          });
          context.commit('updateInfo', info);
          context.commit('setTabs', tabs);
          context.commit('setAdmission', admission);
        } else {
          context.commit('updateInfo', false);
        }
      }).catch(err => {
        console.log(err);
        // context.commit('updateInfo', false);
      });
    }
  }
})
